export default "__VITE_ASSET__6a27abd8__"